module.exports = __webpack_public_path__ + "img/Verified - true.6a0862a1.svg";